'use client';

import { cn } from '@/lib/utils';

import { LOCALE_CHIP_LABELS } from '@/i18n/locale-chip-labels';
import type { AppLocale } from '@/i18n/locales';

export function LocaleChip({
  code,
  selected,
  disabled,
  onSelect,
}: {
  code: AppLocale;
  selected: boolean;
  disabled: boolean;
  onSelect: () => void;
}) {
  const { native, region } = LOCALE_CHIP_LABELS[code];
  return (
    <button
      type='button'
      disabled={disabled}
      aria-pressed={selected}
      aria-label={`${native}, ${region}`}
      onClick={onSelect}
      className={cn(
        'rounded-lg border bg-background px-3 py-2.5 text-start text-sm transition-colors hover:bg-accent/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',
        selected ? 'border-primary ring-2 ring-primary/25' : 'border-border',
      )}
    >
      <div className='font-semibold leading-tight'>{native}</div>
      <div className='mt-0.5 text-xs text-muted-foreground'>{region}</div>
    </button>
  );
}
